import Dexie from 'dexie';

export const db = new Dexie('palletNumber');

db.version(3).stores({
    monitor: 'pickNumber, id, pickName, matName, loadingRoute, unloadingRoute, vehicleModel, numberPlate, driver, phoneNumber, shipperName, createTime, updateTime, timeConsuming, fileList, saveTime, remark, startTime, isClaim' 
  })

//startTime:领取时间
//isClaim:是否领取


